export default __webpack_public_path__ + "static/media/joinCommunity.b6af0f0f.png";